module.exports = __webpack_public_path__ + "static/media/keno.f5e568c8.png";